/**
 * app.js — 自前フロントエンドのオーケストレータ (バニラ ES モジュール)
 *
 * Material Dashboard / jQuery に依存しない。各モジュールは data-* フックを
 * スキャンして自己初期化する。ページ側のインライン <script> は段階的に廃止する。
 */
import { initSidebar } from './modules/sidebar';
import { initMenu } from './modules/menu';
import { initConfirm } from './modules/confirm';
import { initModal } from './modules/modal';

function boot() {
  initSidebar();
  initMenu();
  initConfirm();
  initModal();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', boot);
} else {
  boot();
}
